module.exports = __webpack_public_path__ + "media/svg-new/warning-07d7be2e.svg";